import http from '../api/api'
import config from '../api/constants'

const calculateLoanEMI = async ({ loanAmount, tenor, interestRate }) => {
  try {
    const response = await http.post(config.apiRoute.CALCULATE_LOAN_DEPOSIT, {
      accountType: 'L',
      requestId: 'LOANSCALCULATOR',
      principalAmount: loanAmount,
      tenor: tenor,
      interestRate: interestRate,
      // userName: username,
    })
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const calculateDepositInterest = async ({ loanAmount, tenor, interestRate }) => {
  try {
    const response = await http.post(config.apiRoute.CALCULATE_LOAN_DEPOSIT, {
      accountType: 'D',
      requestId: 'DEPOSITSCALCULATOR',
      principalAmount: loanAmount,
      tenor: tenor,
      interestRate: interestRate,
    })
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const CalculatorService = {
  calculateLoanEMI,
  calculateDepositInterest
}

export default CalculatorService